// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__23Dsb","challengeStep":"Footer_challengeStep__M22go","inputFooter":"Footer_inputFooter__arT86"};